import { css } from "@emotion/react";

export const root = css({
  display: "grid",
  gridTemplateColumns: "1fr auto 1fr",
  height: "100%",
  columnGap: 16,
});

export const dataGridColumn = css({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
  minWidth: 0,
});

export const buttonsPanel = css({
  height: "calc(100% - 30px)",
  marginTop: 30,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: 10,
});

export const dataGridContainer = css({
  flexGrow: 1,
  minHeight: 0,
});
